import { useRef, useEffect, useContext } from "react";
import Chart from "chart.js/auto";
import { Spin } from "antd";
import { STATUS } from "../../constants";
import { memo } from "react";
import { UserContext } from "../../context";

const Chart17 = memo(({ kanbanFilterInfo, status }) => {
  const { parkId } = useContext(UserContext);
  const filterData = kanbanFilterInfo.filter((item) => item.cloumn === 2);
  const element = useRef();
  const allyear = Array.from(
    { length: 5 },
    (_, index) => new Date().getFullYear() - 4 + index
  );
  useEffect(() => {
    let counts = [];
    if (filterData.length > 0) {
      const data = filterData[0].context
        .filter((item) => allyear.includes(Number.parseInt(item.year)))
        .sort((a, b) => Number.parseInt(a.year) - Number.parseInt(b.year));

      counts = allyear.map((year) => {
        const item = data.find((obj) => obj.year === year.toString());
        return item ? item.count : 0;
      });
    }

    const chart = new Chart(element.current, {
      type: "line",
      data: {
        labels: allyear,
        datasets: [
          {
            data: parkId === 69 ? [50, 97, 100, 135, 158] : counts,
            fill: true,
            borderColor: "#2a9d8f",
          },
        ],
      },
      options: {
        scales: {
          y: {
            min: 0,
            // max: 160,
            // ticks: { stepSize: 1 }
          },
        },
        aspectRatio: 1.5,
        layout: {
          // padding: 16
        },
        plugins: {
          legend: false,
        },
      },
    });
    return () => chart.destroy();
  }, [filterData, allyear]);
  return (
    <Spin spinning={status === STATUS.idle}>
      <canvas ref={element} />
    </Spin>
  );
});

export default Chart17;
